"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTableRowActions = exports.SmartTableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Table_1 = __importDefault(require("../../ui/Table"));
var _ = __importStar(require("lodash"));
var Accordion_1 = require("../../ui/Accordion");
var SmartTableCell_1 = require("./SmartTableCell");
var UiAction_1 = require("../../uiAction/UiAction");
var Animations_1 = require("../../util/Animations");
var Button_1 = require("../../ui/Button");
var IconSymbols_1 = require("../../generated/IconSymbols");
var enums_1 = require("../../enums");
var SmartTable_1 = require("./SmartTable");
var SmartTableRow = function (props) {
    var _a, _b;
    var rowRef = (0, react_1.useRef)(null);
    var actions = props.actions || (props.actionsFn ? props.actionsFn(props) : null);
    var shouldRenderAccordion = props.isAccordion && props.renderAccordionContent && !props.isBulkMode;
    return ((0, jsx_runtime_1.jsx)(Table_1.default.Row, __assign({ ref: rowRef, className: "smart-table__row ".concat(props.className || "", " ").concat(props.index % 2 === 0
            ? "smart-table__row--odd"
            : "smart-table__row--even") }, { children: shouldRenderAccordion ? ((0, jsx_runtime_1.jsx)(Accordion_1.Accordion, __assign({ isDynamicallyLoaded: true, side: "left", actions: null, isArrowInteractiveOnly: true, header: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "smart-table__accordion-header" }, { children: [(0, jsx_runtime_1.jsx)(RowColumns, { row: props, headers: props.headers }), (0, jsx_runtime_1.jsx)(exports.SmartTableRowActions, { leftOffset: props.actionOffset, maxHeight: (_a = rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight, actions: actions, content: props.content })] })), onClick: function () { return window.dispatchEvent(new Event("resize")); } }, { children: props.renderAccordionContent(props) }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(RowColumns, { row: props, headers: props.headers }), (0, jsx_runtime_1.jsx)(exports.SmartTableRowActions, { leftOffset: props.actionOffset, maxHeight: (_b = rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight, actions: actions, content: props.content })] })) })));
};
exports.SmartTableRow = SmartTableRow;
var RowColumns = function (_a) {
    var row = _a.row, headers = _a.headers;
    var col = [];
    var headerCols = headers.slice(0);
    var s = headerCols.map(function (col, k) {
        return ((0, jsx_runtime_1.jsx)(Table_1.default.Col, __assign({ className: "".concat(col.id === "actions" ? "smart-table-cell--action-placeholder" : "", "\n        ").concat("smart-table-cell--" + _.kebabCase(col.id), " ").concat(col.cellClassName || "", " smart-table-cell--").concat(col.columnWidthSize ? col.columnWidthSize : enums_1.UiSizes.XXS), onClick: function () {
                if (col.id !== "actions") {
                    row.onRowClick && row.onRowClick(row);
                }
            } }, { children: (0, jsx_runtime_1.jsx)(SmartTableCell_1.SmartTableCell, { col: col, row: row.content }) }), "row-" + row.index + "-" + k));
    });
    col = col.concat(s);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: col });
};
var SmartTableRowActions = function (_a) {
    var actions = _a.actions, content = _a.content, maxHeight = _a.maxHeight, leftOffset = _a.leftOffset;
    var _b = (0, react_1.useState)(false), isActionsHidden = _b[0], setIsActionsHidden = _b[1];
    if (actions.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            maxHeight: maxHeight,
            left: isActionsHidden
                ? leftOffset + actions.length * SmartTable_1.ACTION_BUTTON_WIDTH
                : leftOffset
        }, className: "smart-table__actions" }, { children: [!isActionsHidden &&
                actions.map(function (e, i) {
                    return ((0, jsx_runtime_1.jsx)(SmartTableAction, __assign({ label: e.label, animationDelay: actions.length - i }, { children: (0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: e, contextModel: content }) }), i));
                }), (0, jsx_runtime_1.jsx)(SmartTableAction, __assign({ className: "smart-table__action--toggle", label: isActionsHidden ? "Expand" : "Collapse", animationDelay: 0 }, { children: (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { symbol: !isActionsHidden
                        ? IconSymbols_1.IconSymbols.ChevronRight
                        : IconSymbols_1.IconSymbols.ChevronLeft, onClick: function () { return setIsActionsHidden(!isActionsHidden); }, type: Button_1.ButtonTypes.LINK }) }))] })));
};
exports.SmartTableRowActions = SmartTableRowActions;
var SmartTableAction = function (props) {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "smart-table__action ".concat(Animations_1.Animations.ZOOM_IN, " delay-").concat(props.animationDelay, " speed-05") }, { children: [props.children, (0, jsx_runtime_1.jsx)("div", __assign({ className: "smart-table__action-label" }, { children: (0, jsx_runtime_1.jsxs)("p", __assign({ className: "my-0" }, { children: [" ", props.label] })) }))] })));
};
